export let TrackingScreen;
(function (TrackingScreen) {
  TrackingScreen["PRODUCT_UPDATES"] = "product updates";
})(TrackingScreen || (TrackingScreen = {}));
export let TrackingSubscreen;
(function (TrackingSubscreen) {
  TrackingSubscreen["ALL"] = "all";
  TrackingSubscreen["HEADER"] = "header";
  TrackingSubscreen["IN_BETA"] = "in beta";
  TrackingSubscreen["IN_DEVELOPMENT"] = "in development";
  TrackingSubscreen["LIVE"] = "live";
  TrackingSubscreen["NEW_TO_YOU"] = "new to you";
  TrackingSubscreen["PUBLIC_BETAS"] = "public betas";
  TrackingSubscreen["RECOMMENDED"] = "recommended";
  TrackingSubscreen["SCHEDULED_FOR_RELEASE_CALENDAR"] = "scheduled for release - calendar";
  TrackingSubscreen["SCHEDULED_FOR_RELEASE_TABLE"] = "scheduled for release - table";
  TrackingSubscreen["SUNSET"] = "sunset";
  TrackingSubscreen["UPDATE_PANEL"] = "update panel";
  TrackingSubscreen["YOUR_BETAS"] = "your betas";
})(TrackingSubscreen || (TrackingSubscreen = {}));
export let TrackingFeature;
(function (TrackingFeature) {
  TrackingFeature["BANNER"] = "banner";
  TrackingFeature["BETA_LEGAL_TERMS"] = "beta legal terms";
  TrackingFeature["CTA_FOOTER"] = "cta footer";
  TrackingFeature["DATE_FILTER"] = "date filter";
  TrackingFeature["HERO_IMAGE"] = "hero image";
  TrackingFeature["IMPACT_LEVELS_FILTER"] = "impact levels filter";
  TrackingFeature["MULTI_SELECT_FILTER"] = "multi select filter";
  TrackingFeature["PRICING_LINK"] = "pricing link";
  TrackingFeature["SEARCH_BAR"] = "search bar";
  TrackingFeature["SIDEBAR_FILTER"] = "sidebar filter";
  TrackingFeature["TYPE_FILTER"] = "type filter";
  TrackingFeature["SCHEDULED_FOR_RELEASE_VIEW"] = "scheduled for release view";
})(TrackingFeature || (TrackingFeature = {}));
export let TrackingAction;
(function (TrackingAction) {
  TrackingAction["CLICK"] = "click";
  TrackingAction["VIEW"] = "view";
  TrackingAction["SEARCH"] = "search";
})(TrackingAction || (TrackingAction = {}));